import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { PapiDeviation } from '@wix/da-papi-types';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';

/** Will open the tier popup in edit mode if given a deviation
 *  or in create mode if given none */
export default function useTierPopup(
  deviation?: PapiDeviation,
  afterActionUrl?: string
): () => void {
  const dispatch = useDispatch();
  return useCallback(() => {
    return dispatch(
      pushModal(ModalType.TIER_EDIT, {
        wrapInModal: false,
        params: { deviation, afterActionUrl },
      })
    );
  }, [dispatch, deviation, afterActionUrl]);
}
